export default {"src":"/_next/static/media/swirly_doodle.14525443.svg","height":48,"width":281,"blurWidth":0,"blurHeight":0};